import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import LoginPage from '@/pages/LoginPage.vue'
import AppShell from '@/layouts/AppShell.vue'
import PursuitPage from '@/pages/PursuitPage.vue'
import FleetPage from '@/pages/FleetPage.vue'
import { authGuard } from './guards'

const devRoutes: RouteRecordRaw[] = import.meta.env.DEV
  ? [
      {
        path: '/design-system',
        name: 'design-system',
        component: () => import('@/pages/DesignSystemPage.vue'),
        meta: { requiresAuth: false },
      },
    ]
  : []

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    component: AppShell,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'overview',
        component: () => import('@/pages/OverviewPage.vue'),
      },
      { path: 'pursuit', name: 'pursuit', component: PursuitPage },
      {
        path: 'pursuit/plate/:plate',
        name: 'pursuit-plate',
        component: () => import('@/pages/PlateDetailPage.vue'),
      },
      { path: 'fleet', name: 'fleet', component: FleetPage },
      {
        path: 'fleet/:vehicle_id',
        name: 'fleet-vehicle',
        component: () => import('@/pages/VehicleDetailPage.vue'),
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@/pages/HistoryPage.vue'),
      },
      {
        path: 'stats',
        name: 'stats',
        component: () => import('@/pages/StatsPage.vue'),
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/pages/SettingsPage.vue'),
      },
      {
        path: 'guide',
        name: 'guide',
        component: () => import('@/pages/UserGuidePage.vue'),
      },
      {
        path: 'unidentified',
        name: 'unidentified',
        component: () => import('@/pages/UnidentifiedPage.vue'),
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'overview' },
  },
  ...devRoutes,
]

export const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

router.beforeEach(authGuard)
